// extracted by mini-css-extract-plugin
export var bodySections = "_8w-8";
export var gray = "_8w-7";
export var green = "_8w-4";
export var iconContainer = "_8w-9";
export var iconWidgetContainer = "_8w-1";
export var phoneIcon = "_8w-2";
export var red = "_8w-5";
export var statusDot = "_8w-3";
export var widgetContainer = "_8w-0";
export var yellow = "_8w-6";